import { Link } from 'react-router-dom';
import { Compass, Inbox } from 'lucide-react';
import { Button, Card, EmptyState, Page } from '../components/ui';

export function NotFoundPage() {
  return (
    <Page>
      <Card className="mx-auto mt-10 max-w-md">
        <EmptyState
          className="py-14"
          icon={<Compass className="h-6 w-6" />}
          title="Page not found"
          description="That page doesn't exist, or it moved. Head back to your inbox."
          actions={
            <Link to="/inbox">
              <Button variant="primary" icon={<Inbox className="h-4 w-4" />}>
                Go to inbox
              </Button>
            </Link>
          }
        />
      </Card>
    </Page>
  );
}
